export { default } from "./useIsStuckVertically";
